/* eslint-disable */
export default {
  feedbackHeader: 'フィードバックを送信',
  back: '戻る',
  revert: '元に戻す',
  instruction:
    'お客様のフィードバックは重要です。アプリの使用に関する問題、機能のリクエストやバグの報告など、いつでも喜んでサポートいたします。',
  fillForm: '以下のフォームに記入し、クリックしてください。 ',
  useMailBox:
    ' または、メールボックスを使用して依頼内容を次の宛先まで送信してください： ',
  email: 'Eメールアドレス',
  reply: '(こちらに返信が届きます)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'フィードバックのトピック',
  topicPlaceHolder: 'いずれかを選択してください',
  bugReport: 'バグを報告',
  featureRequest: '機能に関するリクエスト',
  others: 'その他',
  subject: '件名',
  subjectPlaceHolder: 'どのようなサポートが必要ですか',
  description: '詳細説明',
  descriptionPlaceHolder: 'できるだけ詳しくご記入ください',
  send: 'フィードバックを送信',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
